var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.308 258.56c28.538 53.408 44.717 114.415 44.717 179.2 0 210.302-170.483 380.785-380.785 380.785s-380.785-170.483-380.785-380.785c0-210.302 170.483-380.785 380.785-380.785 128.272 0 241.731 63.425 310.725 160.625h-288.283v40.96h313.626zM522.24 17.92c-231.871 0-419.84 187.969-419.84 419.84s187.969 419.84 419.84 419.84c231.871 0 419.84-187.969 419.84-419.84s-187.969-419.84-419.84-419.84zM544.79 616.96v40.96h289.002c7.741-11.587 16.103-25.241 25.085-40.96h-314.087zM544.804 417.28v40.96h358.027c1.344-22.517 1.344-20.48 0-40.96h-358.027zM503.809 818.617c20.552 0.949 20.552 0.949 41.104 0 0-333.849 0-586.954 0-759.316 0-6.238-40.96-6.596-40.96-0.537 0 172.481-0.048 425.765-0.144 759.853z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.eda726a54e9724a518e007f09ac83150.svg";
export { ForwardRef as ReactComponent };